import React from 'react';
import Alert from '../Alert';
import Row from '../tag/Row';

const QuestionnairesTopAlert = () => {
  return (
    <Alert
      type="info"
      style={{
        textAlign: 'center',
        fontSize: '16px',
        lineHeight: '22px',
        padding: '10px',
      }}
    >
      <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
        <p>
          Lähetettyäsi kyselyvastaukset et enää pääse itse muokkaamaan niitä.
          <br />
          Lähetettyjä vastauksia voidaan täydentää ja muokata vastaanotolla
          hoitohenkilökunnan kanssa.
        </p>
        <br />
        <p>
          Osa vastatuista kyselyistä jää näkyviin OmaTaysin täytettyihin
          kyselyihin ja voit sieltä tarkastella antamiasi vastauksia. Mikäli et
          löydä täyttämääsi kyselyä OmaTaysista, voit nähdä vastauksesi
          vastaanottosi yhteydessä.
        </p>
      </Row>
    </Alert>
  );
};

export default QuestionnairesTopAlert;
